<!-- Modal -->
<div id="myModal" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="modal-title">{{settings.name}}</h4>
      </div>
      <div class="modal-body">

        <user-management-user-settings *ngIf="true" [updateCommandEx]="updateCommand" [type]="2" [user]="user"></user-management-user-settings>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="save()" data-dismiss="modal">{{(settings.type==5? 'common.save' : 'common.delete') | translate}}</button>
        <button type="button" class="btn btn-default" data-dismiss="modal">{{ 'common.cancel' | translate }}</button>
      </div>
    </div>
  </div>
</div>
